import { Avatar, type AvatarProps } from '@mui/material';

import { getAvatarColor, getInitials } from '@/shared/utils/avatar';

export interface UserAvatarProps extends Omit<AvatarProps, 'alt' | 'children' | 'src'> {
  alt?: string;
  email?: string | null;
  name?: string | null;
  size?: number;
  src?: string | null;
  userId?: string | null;
}

export function UserAvatar({
  alt,
  email,
  name,
  size = 32,
  src,
  sx,
  userId,
  ...props
}: UserAvatarProps) {
  const label = alt?.trim() || name?.trim() || email?.trim() || 'User';
  const seed = userId || email || name || label;
  const baseSx: AvatarProps['sx'] = {
    bgcolor: getAvatarColor(seed),
    color: 'common.white',
    fontSize: Math.max(12, Math.round(size * 0.44)),
    height: size,
    width: size,
  };
  const mergedSx = Array.isArray(sx) ? [baseSx, ...sx] : [baseSx, sx].filter(Boolean);

  return (
    <Avatar {...props} alt={label} src={src || undefined} sx={mergedSx}>
      {getInitials(label)}
    </Avatar>
  );
}

export default UserAvatar;
